import { Base, Component, Inject, Mixins } from '@/vue-property-decorator'
import { _CopywritingBase as CopywritingBase } from './cssVar/copywritingBase'
import { _CopywritingDefault as CopywritingDefault } from './cssVar/copywritingDefault'
import { _CopywritingSmall as CopywritingSmall } from './cssVar/copywritingSmall'
import { GetCssVarManager } from '@/views/game/components/gameCardSuit/components/baseCssVarProvide'
import { LandscapeProps } from '../../../components/basePropsConfig'
import BaseCssVarInject from '../../../../../components/baseCssVarInject'
import style from './style.module.scss'
export { CopywritingBase, CopywritingDefault, CopywritingSmall }
export type CopywritingCssVarManager = GetCssVarManager<CopywritingBase>

/** 游戏文案区域 */
@Component<Copywriting>({
  name: 'Copywriting'
})
export default class Copywriting extends Mixins<
  Base<unknown, unknown, unknown>,
  BaseCssVarInject<CopywritingBase>
>(Base, BaseCssVarInject) {
  @Inject('cardProps') cardProps!: Required<LandscapeProps>

  /** 获得默认样式cssVar */
  public static getCssVarDefault = () => new CopywritingDefault()
  /** 获得小号样式cssVar */
  public static getCssVarSmall = () => new CopywritingSmall()

  render() {
    const { gameName, logoUrl, isJackpot } = this.cardProps
    return (
      <div
        class={{
          [style['copywriting']]: true,
          [style['show-bonus-pool']]: isJackpot as boolean,
          [style[`type-${this.finialCssType}`]]: Boolean(this.finialCssType)
        }}
      >
        <div class={style['headline']}>
          {logoUrl && (
            <my-img
              class={style['logo']}
              src={logoUrl}
              options={{ type: 'div' }}
            />
          )}
          <div class={style['name']}>{gameName}</div>
        </div>
      </div>
    )
  }
}
